import React from "react";
import FormEmpresa from "./FormEmpresa.js"; // Reutilizamos el formulario que ya tienes

const Configuracion = () => {
  return (
    <div>
      <h2>Configuración</h2>
      <FormEmpresa />
    </div>
  );
};

export default Configuracion;
